import { render } from "./DataEntryButtons.vue?vue&type=template&id=2f129915&scoped=true"
import script from "./DataEntryButtons.vue?vue&type=script&lang=js"
export * from "./DataEntryButtons.vue?vue&type=script&lang=js"

import "./DataEntryButtons.vue?vue&type=style&index=0&id=2f129915&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f129915"]])

export default __exports__